import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import { getIcon } from '@cont/NewPreSubscribed/utils';
import React, { forwardRef } from 'react';
import { useIsMobile } from '@stores/AppCommonData';
import { getFirstLetterForIcon } from '@cont/SeeAll/utils';
import useTestSeriesInfo from './useTestSeriesInfo';

const Container = styled.div`
  margin-top: ${Spacings.SPACING_14B};
  ${mediaQuery.uptoMobile} {
    margin-top: 0;
  }
`;

const Title = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  height: fit-content;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledP1 = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
`;

const ImageWrapper = styled.div`
  margin-right: ${Spacings.SPACING_4B};
  width: ${Spacings.SPACING_10B};
  height: ${Spacings.SPACING_10B};

  & > svg {
    width: ${Spacings.SPACING_10B};
    height: ${Spacings.SPACING_10B};
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 224px 224px;
  grid-gap: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
    grid-gap: ${Spacings.SPACING_7B};
  }
`;

const renderSyllabus = (syllabus = []) => {
  return syllabus.map(({ subject, uid }) => {
    const letter = getFirstLetterForIcon(subject);

    return (
      <FlexRow key={uid}>
        <ImageWrapper>{getIcon(letter)}</ImageWrapper>

        <FlexColumn>
          <StyledP1 variant="p1">{subject}</StyledP1>
          <Typography variant="p3" color="var(--color-text-secondary)">
            Full Syllabus
          </Typography>
        </FlexColumn>
      </FlexRow>
    );
  });
};

const Syllabus = forwardRef((_, ref) => {
  const { data } = useTestSeriesInfo();
  const { programmeSyllabus } = data;
  const isMobile = useIsMobile();
  return (
    <Container ref={ref}>
      {!isMobile && <Title variant="h4">Syllabus</Title>}
      <Wrapper>{renderSyllabus(programmeSyllabus)}</Wrapper>
    </Container>
  );
});

Syllabus.displayName = 'Syllabus';

export default React.memo(Syllabus);
